module.exports = __webpack_public_path__ + "img/Group.9de0289d.svg";